// @ts-nocheck — W2.1 in-place migration: TS strict aplicado em waves subsequentes
import React, { Component, createRef } from "react";
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import { SessionStore } from "../../utils/SessionStore";

import * as smartMapActions from "../../actions/SmartMap";
import * as mapUtils from "./mapUtils";

// W13d: AntD substituido por Mantine
import { Button, Checkbox, Switch, Select, Popover, Group, Loader, Stack, Paper } from "@mantine/core";
import {
  IconInfoCircle,
  IconArrowBackUp,
  IconCaretDown,
  IconChevronDown,
  IconPencil,
  IconQuestionMark,
} from "@tabler/icons-react";
// Shim local: FontAwesomeIcon usado em alguns spots restantes → Tabler InfoCircle como fallback
const FontAwesomeIcon = ({ icon, size }: { icon: any; size?: any }) => {
  const sz = typeof size === "string" ? 14 : size ?? 14;
  if (icon === "info") return <IconInfoCircle size={sz} />;
  if (icon === "undo-alt") return <IconArrowBackUp size={sz} />;
  if (icon === "caret-down") return <IconCaretDown size={sz} />;
  if (icon === "pen" || icon === "pencil") return <IconPencil size={sz} />;
  return null;
};

import ResizeObserver from "resize-observer-polyfill";

import Map from "ol/Map";
import AttributionControl from "ol/control/Attribution";
import { defaults as defaultControls } from "ol/control";

import { Icon } from 'ol/style';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

//import Control from "ol/control";

import Style from "ol/style/Style";
import StrokeStyle from "ol/style/Stroke";
import FillStyle from "ol/style/Fill";
import MultiPolygon from "ol/geom/MultiPolygon";

import View from "ol/View";
import * as Proj from "ol/proj";
import * as Extent from "ol/extent";
import ScaleLine from "ol/control/ScaleLine";

import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSONFormat from "ol/format/GeoJSON";

import LayerDataHandler from "./geocloud2/LayerDataHandler.js";
import LayerDataHandlerListenerKeys from "./geocloud2/lov/LayerDataHandlerListenerKeys.js";
import CanvasLayer from "./geocloud2/layer/CanvasLayer.js";

import DragBox from "ol/interaction/DragBox";
import Modify from "ol/interaction/Modify";
import Draw from "ol/interaction/Draw";
import * as EventsCondition from "ol/events/condition";

import "ol/ol.css";
import "./SmartMap.css";
import SelectionLayerTileSource from "./geocloud2/source/SelectionLayerTileSource.js";
import MeasureTool from "./MeasureTool";
import GoToCoordinatesTool from "./GoToCoordinatesTool";
import pngSource from './map-marker.png';

export const mapKey = {
  GEOFINANCEIRO: "[GEOFINANCEIRO]",
  GEOFINANCEIRO_REL_UNIDADE: "[GEOFINANCEIRO_REL_UNIDADE]",
  ARQUIVOS_DIGITALIZADOS: "[ARQUIVOS_DIGITALIZADOS]",
  AUDIT: "[AUDIT]",

  SMARTVIEW: "[SMARTVIEW]",
  GEOFINANCEIRO_REL_UNIDADE_SMARTVIEW: "[GEOFINANCEIRO_REL_UNIDADE_SMARTVIEW]",
  ARQUIVOS_DIGITALIZADOS_SMARTVIEW: "[ARQUIVOS_DIGITALIZADOS_SMARTVIEW]",

  SMARTPUBLIC: "[SMARTPUBLIC]",
  PUBLIC_ARQUIVOS_DIGITALIZADOS: "[PUBLIC_ARQUIVOS_DIGITALIZADOS]",
  GEOFINANCEIRO_REL_UNIDADE_PUBLIC: "[GEOFINANCEIRO_REL_UNIDADE_PUBLIC]",
  LOGRADOUROS: "[LOGRADOUROS]",
  SMARTVIEW_LOGRADOUROS: "[SMARTVIEW_LOGRADOUROS]",

  REQUEST_ATENDIMENTO: "[REQUEST_ATENDIMENTO]",
  REQUEST_PENDENCIA: "[REQUEST_PENDENCIA]",
  AREAS_OBSERVACAO_LANCAR: "[AREAS_OBSERVACAO_LANCAR]",

  // GAT / Rede SIM integration map key (usado por VisualizadorGatRedeSim)
  GAT_REDE_SIM: "[GAT_REDE_SIM]",

  ///deprecated
  AREAS_OBSERVACAO_LISTAR: "[AREAS_OBSERVACAO_LISTAR]",
};

const MUNDO_3857 = [[-20037508.34, -20037508.34], [20037508.34, -20037508.34], [20037508.34, 20037508.34], [-20037508.34, 20037508.34], [-20037508.34, -20037508.34]];

function poligonos(geometria) {
  if (!geometria) return [];
  switch (geometria.getType()) {
    case "Polygon":
      return [geometria.getCoordinates()];
    case "MultiPolygon":
      return geometria.getCoordinates();
    case "GeometryCollection":
      return geometria.getGeometries().flatMap(poligonos);
    default:
      return [];
  }
}

const SEM_DESTAQUE = { temArea: false, mascara: null };

// The dim-everything-else effect is a world-sized polygon with the highlighted parcels as holes,
// plus each parcel hole as a filled polygon so it stays dimmed. Rebuilt only when the geometry
// changes (the edit tool modifies it in place).
const destaques = new WeakMap();

function destaqueDe(geometria) {
  if (!geometria) return SEM_DESTAQUE;
  const guardado = destaques.get(geometria);
  if (guardado && guardado.revisao === geometria.getRevision()) return guardado;
  const partes = poligonos(geometria);
  const destaque = {
    revisao: geometria.getRevision(),
    temArea: partes.length > 0,
    mascara: new MultiPolygon([
      [MUNDO_3857, ...partes.map(aneis => aneis[0])],
      ...partes.flatMap(aneis => aneis.slice(1).map(furo => [furo])),
    ]),
  };
  destaques.set(geometria, destaque);
  return destaque;
}

class SmartMap extends Component {

  constructor(props) {
    super(props);

    // WB.1: React 19 refactor — string refs (this.refs.X) -> createRef
    this.mapRef = createRef();
    this.divContainerRef = createRef();

    this.state = {
      popoverVisible: false,

      loadingMessage: "",
      loadingPercent: 0,

      // W13s: overlay spinner enquanto tiles do mapa carregam
      // (true ate primeiro 'rendercomplete' do OL apos init).
      loadingTiles: true,

      mapConfig: null,

      activeBasemap: "[BRANCO]",
      lastBasemap: "[BRANCO]",
      activeLayer: [],
      activeDynamicLayer: [],
      showLayer: true,
    };
    this.__basemaps = [];
    this.__layers = [];
    this._featureLayers = [];
    this._loadingStatus = {};
    this._themeValue = null;
    this._themeLayerId = null;
    this._styleLayerId = null;
    this._styleValue = null;
    this._filteredColumnsLayerId = null;
    this._filteredColumnsValue = null;
    this.__activeIdentify = true;
    this._panning = false;
  }

  static propTypes = {
    infoText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    identifyOnExtent: PropTypes.func,
    overlays: PropTypes.arrayOf(PropTypes.string),
    //defaultActiveLayer: PropTypes.string,

    controls: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
      action: PropTypes.func.isRequired,
      title: PropTypes.string.isRequired,
    })),
    // Escurece o entorno e contorna o registro destacado (id 0) com halo branco e linha
    // vermelha, legível em tela e em impressão preto e branco.
    destaqueSelecao: PropTypes.bool,
  }

  static defaultProps = {
    infoText: <div>Aproxime a imagem (Zoom +) rolando o scroll do mouse para frente. <br /> Afaste a imagem (Zoom -) rolando o scroll do mouse para trás. <br /> Clique em um lote do mapa para selecioná-lo. <br /> Segure a tecla "Ctrl" + "click" e arraste para selecionar uma área.</div>,
    controls: [],
    identifyOnPixelTolerance: 2,
    destaqueSelecao: false
  }

  componentDidMount() {
    // WB.1: appConfig vem de state.container.config (async, via getConfig em AppLayout).
    // Pode estar null no primeiro mount — initMap espera até estar disponível.
    if (this.props.appConfig) {
      this.initMap();
    }
  }

  initMap = () => {
    const { mapKey } = this.props;

    this.createMap();
    this.createResizeObserver();

    this.props.getMapConfig(mapKey, ({ data }) => {

      this.setState({ mapConfig: data }, () => {
        this.initializeMap();
        this.applyTheme();
        this.applyStyles();
        this.applyFilteredColumns();
      });
    });
  }

  componentWillUnmount() {
    // WB.1: guards porque initMap pode não ter sido chamado se appConfig nunca chegou
    if (this.map && this.changeMapSize) {
      this.map.un("change:size", this.changeMapSize);
    }

    if (this.__resizeObserver) {
      this.__resizeObserver.disconnect();
      this.__resizeObserver = null;
    }

    // W13s: limpa fallback do spinner se ainda nao disparou
    if (this.__tileLoadFallback) {
      clearTimeout(this.__tileLoadFallback);
      this.__tileLoadFallback = null;
    }

    if (this.map) {
      this.unloadFeatureLayers();
      // React 19 strict mode roda componentDidMount 2x em DEV. Sem detach
      // explícito do target + dispose, o primeiro Map fica zombie no DOM
      // (.ol-viewport duplicado embaixo do real). setTarget(null) desliga
      // o map do container, dispose() libera handlers.
      try { this.map.setTarget(null); } catch (e) { /* noop */ }
      try { this.map.dispose?.(); } catch (e) { /* noop */ }
      this.map = null;
    }
  }
  createMap = () => {
    const { appConfig } = this.props;

    const attributionControl = new AttributionControl({
      collapsible: false,
      collapsed: false
    });
    const scaleLineControl = new ScaleLine();

    let mapInitialPositionLongitude = appConfig.mapInitialPositionLongitude;
    let mapInitialPositionLatitude = appConfig.mapInitialPositionLatitude;
    let mapInitialPositionZoomLevel = appConfig.mapInitialPositionZoomLevel;

    if (typeof this.props.defaultLon !== "undefined" && typeof this.props.defaultLat !== "undefined" && typeof this.props.defaultZoom !== "undefined") {
      mapInitialPositionLongitude = this.props.defaultLon;
      mapInitialPositionLatitude = this.props.defaultLat;
      mapInitialPositionZoomLevel = this.props.defaultZoom;
    }
    else if (typeof this.props.config !== "undefined" && typeof this.props.config.defaultLon !== "undefined" && typeof this.props.config.defaultLat !== "undefined" && typeof this.props.config.defaultZoom !== "undefined") {
      mapInitialPositionLongitude = this.props.config.defaultLon;
      mapInitialPositionLatitude = this.props.config.defaultLat;
      mapInitialPositionZoomLevel = this.props.config.defaultZoom;
    }

    this.map = new Map({
      target: this.mapRef.current,
      layers: [],
      view: new View({
        center: Proj.fromLonLat([
          mapInitialPositionLongitude,
          mapInitialPositionLatitude
        ]),
        zoom: mapInitialPositionZoomLevel,
        maxZoom: 22
      }),
      controls: defaultControls({ attribution: false }).extend([
        attributionControl,
        scaleLineControl
      ])
    });

    this.changeMapSize = () => {
      var collapsed = this.map.getSize()[0] < 400;

      attributionControl.setCollapsible(collapsed);
      attributionControl.setCollapsed(collapsed);
    };

    this.map.on("change:size", this.changeMapSize);
  }

  initializeMap = () => {
    const { mapConfig } = this.state;
    const { dynamicLayers } = this.props;

    this.__basemaps = this.loadBaseMap();
    this.__layers = this.loadOverLays();
    this.__geoJsonLayer = this.loadGeoJsonLayer();
    this.__markerLayer = this.loadMarkerLayer();

    // =============================================================
    // Create Selection Layer
    this._selectedDataSource = new SelectionLayerTileSource();

    this._selectedDataLayer = new CanvasLayer({
      zIndex: 101,
      visible: true,
      source: this._selectedDataSource
    });

    this.map.addLayer(this._selectedDataLayer);
    // =============================================================

    // =============================================================
    // Dynamic Layers

    if (dynamicLayers) {
      const { defaultFilters } = this.props;

      const sessionKey = SessionStore.getSessionKey();
      const apiUrl = process.env.REACT_APP_API_URL;

      this._featureLayers = [];
      var featureLayers = dynamicLayers.map(x => {
        const ldh = new LayerDataHandler(x, sessionKey, apiUrl);

        if (defaultFilters) {
          ldh.setStyles(defaultFilters.themeStyles);
          ldh.setTheme(defaultFilters.themeFieldDefinitionId);
          ldh.setFilteredColumns(defaultFilters.fields);
        }

        return ldh;
      });

      this.loadFeatureLayers(featureLayers);

      featureLayers.forEach(x => {
        x.setVisible(true);
      });
    }

    // ============================================================= 

    this.map.on('movestart', () => {
      this._panning = true;
    });

    this.map.on('moveend', () => {
      this._panning = false;
    });

    if (this.props.identifyOnExtent || this.props.identifyOnLayer) {
      this.initializeIdentify();
    }
    // =============================================================


    // =============================================================
    // Edit Enabled

    if (this.props.onEditGeometry) {
      this.initializeEditGeometry();
    }

    // =============================================================



    // =============================================================
    // Draw Enabled

    if (this.props.onDrawGeometry) {
      var source = this.__geoJsonLayer.getSource();
      var draw = new Draw({
        source: source,
        type: "Polygon",
        condition: (evt) => {
          if (this.__activeIdentify) {
            return EventsCondition.noModifierKeys(evt);
          }
          return false;
        }
      });

      this.map.addInteraction(draw);

      draw.on("drawend", evt => {
        var modifiedGeoJson = source.getFormat().writeGeometry(evt.feature.getGeometry());

        this.map.removeInteraction(draw);


        // --------------------------
        var modify = new Modify({
          source: source,
          deleteCondition: evt => { return EventsCondition.singleClick(evt); },
          condition: (evt) => {
            if (this.__activeIdentify) {
              return EventsCondition.primaryAction(evt);
            }
            return false;
          }
        });

        this.map.addInteraction(modify);

        modify.on("modifyend", evt => {
          var feature = evt.features.getArray()[0];
          var modifiedGeoJson = source.getFormat().writeGeometry(feature.getGeometry());

          this.props.onDrawGeometry(modifiedGeoJson);
        });
        // --------------------------


        this.props.onDrawGeometry(modifiedGeoJson);
      });
    }

    // =============================================================

    //load GeoJson
    this.loadGeoJson();
    const newState = {};

    if (mapConfig.overlaySelecteds) {
      // Defensive: mapConfig pode ter overlaySelecteds sem overlays correspondentes em casos extremos.
      const overlaysList = mapConfig.overlays || [];
      newState.activeLayer = mapConfig.overlaySelecteds.map(x => {
        const overlay = overlaysList.find(y => y.mapService.name === x);
        if (overlay)
          return `${overlay.mapService.id}__${overlay.mapService.serviceName}`;

        return null;
      });
    }

    if (mapConfig.baseMapPrimary)
      newState.activeBasemap = `${mapConfig.baseMapPrimary.id}__${mapConfig.baseMapPrimary.serviceName}`;

    if (mapConfig.baseMapSecondary)
      newState.lastBasemap = `${mapConfig.baseMapSecondary.id}__${mapConfig.baseMapSecondary.serviceName}`;

    newState.showlayer = this.props.config.showlayer !== false;

    if (this.props.config.activeBasemap && this.__basemaps && this.__basemaps.some(x => x.value === this.props.config.activeBasemap))
      newState.activeBasemap = this.props.config.activeBasemap;

    if (this.props.config.lastBasemap && this.__basemaps && this.__basemaps.some(x => x.value === this.props.config.lastBasemap))
      newState.lastBasemap = this.props.config.lastBasemap;

    if (this.props.config.activeLayer && this.__layers) {

      const allowMultipleOverlays = this.state.mapConfig ? this.state.mapConfig.allowMultipleOverlays : false;

      let newActiveLayer = this.props.config.activeLayer.filter(x => this.__layers.some(y => y.value === x))

      if (newActiveLayer && newActiveLayer.length > 0) {
        if (allowMultipleOverlays)
          newState.activeLayer = newActiveLayer;
        else
          newState.activeLayer = [newActiveLayer[newActiveLayer.length - 1]];
      }
    }

    this.setState(newState,
      () => {
        this.updateBasemap();
        this.updateLayer();
        this.updateConfigMap();

        this.map.on('moveend', this.updateConfigMap);

      });

    this.initializeApi();
  }


  loadBaseMap = () => {
    const { appConfig } = this.props;
    const { mapConfig } = this.state;

    const basemaps = [
      { label: "Fundo Branco", value: "[BRANCO]", serviceUrl: '[BRANCO]', serviceName: '[BRANCO]', layer: null }
    ];

    if (mapConfig.baseMaps) {
      mapConfig.baseMaps.forEach(item => {
        const layer = mapUtils.generateLayer(item.mapService, appConfig, this.map);
        layer.layer.setZIndex(1);

        this.map.addLayer(layer.layer);
        basemaps.push(layer);
      });

    }

    return basemaps;
  }

  loadOverLays = () => {
    const { appConfig } = this.props;
    const { mapConfig } = this.state;

    const overlays = [];

    // Backend pode retornar mapConfig sem overlays (tenant sem layers configurados).
    // Guard antes de .length resolve crash que ativava SmartMapFallback em runtime.
    if (mapConfig.overlays && mapConfig.overlays.length > 0) {
      var zindex = mapConfig.overlays.length + 5;
      mapConfig.overlays.forEach(item => {
        const layer = mapUtils.generateLayer(item.mapService, appConfig, this.map);

        layer.layer.setZIndex(zindex--);

        this.map.addLayer(layer.layer);
        overlays.push(layer);
      });
    }

    return overlays;
  }


  loadGeoJsonLayer = () => {

    const cyanStyle = new Style({
      stroke: new StrokeStyle({
        color: "#0ff",
        width: 3
      }),

    });

    const selectExtentStyle = new Style({
      stroke: new StrokeStyle({
        color: "rgba(100,150,0,1)",
        width: 2
      })
    });

    const destaqueStyles = [
      new Style({ geometry: feature => destaqueDe(feature.getGeometry()).mascara, fill: new FillStyle({ color: "rgba(8, 15, 30, 0.5)" }) }),
      new Style({ stroke: new StrokeStyle({ color: "rgba(255, 255, 255, 0.95)", width: 8 }) }),
      new Style({ stroke: new StrokeStyle({ color: "#c92a2a", width: 3 }) }),
    ];

    const source = new VectorSource({
      format: new GeoJSONFormat({ featureProjection: "EPSG:3857" })
    });

    const geoJsonLayer = new VectorLayer({
      visible: true,
      zIndex: 100,
      source: source,
      style: feature => {
        if (feature.get("selectExtent")) return selectExtentStyle;
        if (this.props.destaqueSelecao && feature.getId() === 0 && destaqueDe(feature.getGeometry()).temArea) return destaqueStyles;
        return cyanStyle;
      }
    });

    this.map.addLayer(geoJsonLayer);
    return geoJsonLayer;
  }

  loadGeoJson() {
    if (!this.__geoJsonLayer) return;

    const { geoJson } = this.props;

    var geojsonObject = {
      type: "Feature",
      id: 0,
      geometry: null
    };

    var source = this.__geoJsonLayer.getSource();

    var oldFeature = source.getFeatureById(geojsonObject.id);
    if (oldFeature)
      source.removeFeature(oldFeature);

    if (!geoJson || geoJson.length === 0)
      return;

    if (Array.isArray(geoJson)) {

      geojsonObject.geometry = {
        "type": "GeometryCollection",
        "geometries": geoJson.map(x => {
          if (typeof x === "string")
            return JSON.parse(x);

          return x;
        })
      };
    }
    else {
      if (typeof geoJson === "string") {
        geojsonObject.geometry = JSON.parse(geoJson);
      }
      else {
        geojsonObject.geometry = geoJson;
      }
    }

    var newFeature = source.getFormat().readFeature(geojsonObject);

    source.addFeature(newFeature);
    this.fitGeoJson();
  }

  fitGeoJson() {
    const source = this.__geoJsonLayer?.getSource();
    if (!source?.getFeatureById(0)) return false;
    this.map.getView().fit(source.getExtent(), { maxZoom: 19 });
    return true;
  }

  loadMarkerLayer = ()=>{
    var stl1 = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        imgSize: [32, 32],
        src: pngSource
      })
    });

    const vectorLayer = new VectorLayer({
      visible: true,
      source: new VectorSource(),
      zIndex: 1010, // Higher than geoJsonLayer (1001) to ensure visibility
      style: stl1
    });

    this.map.addLayer(vectorLayer);
    return vectorLayer;
  }

  setMarker = (coord) => {
    if (!this.__markerLayer) {
      return;
    }
    var source = this.__markerLayer.getSource();
    source.clear();

    var iconFeature = new Feature({
      id: 1,
      geometry: new Point(coord),
    });

    source.addFeature(iconFeature);
  }

  clearMarker = () => {
    if (!this.__markerLayer) {
      return;
    }
    var source = this.__markerLayer.getSource();
    source.clear();
  }

  loadFeatureLayers(layerDataHandlerList) {

    this._selectedDataSource.clearSources();

    var cache = {};

    this._featureLayers.forEach(layerItem => {
      this.map.removeLayer(layerItem.mapLayer);

      cache[layerItem.id] = layerItem;
    });

    this._featureLayers = [];

    // callback instantiator
    var createLoadStatusCallback = function (layerId, scope) {
      return (percent, count) => {
        scope._setLoadingStatus(layerId, percent, count);
      };
    };

    var zIndex = 200 + layerDataHandlerList.length;
    var activeDynamicLayer = [];
    for (var i = layerDataHandlerList.length - 1; i >= 0; i--) {
      var layerDef = layerDataHandlerList[i].layerDefinition();

      var newItem = null;

      if (cache[layerDef.id]) {
        //Load Layer from Cache
        newItem = cache[layerDef.id];
        delete cache[layerDef.id];

        this.map.addLayer(newItem.mapLayer);

        this._selectedDataSource.addSource(newItem.mapLayer.getSource());
      }
      else {
        var source = layerDataHandlerList[i].source();

        // Create new Layer
        var newLayer = new CanvasLayer({
          visible: false,
          source: source
        });

        this.map.addLayer(newLayer);

        source.setLoadStatusChangeFunction(createLoadStatusCallback(layerDef.id, this));

        this._selectedDataSource.addSource(source);

        layerDataHandlerList[i].addListener(LayerDataHandlerListenerKeys.LAYER_DEFINITION_CHANGED, this._onLayerDefinitionChanged);
        layerDataHandlerList[i].addListener(LayerDataHandlerListenerKeys.VISIBLE_CHANGED, this._onLayerVisibilityChanged);
        layerDataHandlerList[i].addListener(LayerDataHandlerListenerKeys.GRID_VISIBLE_CHANGED, this._onGridVisibilityChanged);
        layerDataHandlerList[i].addListener(LayerDataHandlerListenerKeys.SEARCH_TEXT_CHANGED, this._onLayerSearchTextChanged);
        layerDataHandlerList[i].addListener(LayerDataHandlerListenerKeys.DISPOSE_REQUESTED, this._onLayerRemoved);
        layerDataHandlerList[i].addListener(LayerDataHandlerListenerKeys.UPDATE_REQUESTED, this._onLayerUpdateRequested);

        newItem = {
          id: layerDef.id,
          label: layerDef.featureName,
          dataHandler: layerDataHandlerList[i],
          mapLayer: newLayer
        };

      }

      newItem.mapLayer.setZIndex(zIndex--);

      this._featureLayers.push(newItem);
      activeDynamicLayer.push(newItem.id);

    }

    this.setState({ activeDynamicLayer });

    //reorder 
    this.__geoJsonLayer.setZIndex(1001);
    this._selectedDataLayer.setZIndex(1001);


    //clear old cache
    for (var key in cache) {
      cache[key].dataHandler.clearData();
    }


    //add mapservice sources
    /* this.mapServiceLayers.forEach(mapserviceItem => {
      mapserviceItem.dataSources.forEach(source => {
        this._selectedDataSource.addSource(source);
      });
    }); */
  }

  unloadFeatureLayers() {
    this._featureLayers.forEach(item => {
      item.dataHandler.clearData();

      this._onLayerRemoved(item.dataHandler);
    });
  }

  applyTheme = () => {
    if (this._featureLayers.length > 0 && !!this._themeLayerId) {
      const feature = this._featureLayers.find(x => x.dataHandler.layerDefinition().id === this._themeLayerId);
      feature.dataHandler.setTheme(this._themeValue);
    }
  }

  setTheme = (layerId, theme) => {
    this._themeLayerId = layerId;
    this._themeValue = theme;
    this.applyTheme();
  }

  applyStyles = () => {
    if (this._featureLayers.length > 0 && !!this._styleLayerId) {
      const feature = this._featureLayers.find(x => x.dataHandler.layerDefinition().id === this._styleLayerId);
      feature.dataHandler.setStyles(this._styleValue);
    }
  }

  setStyles = (layerId, styles) => {
    this._styleLayerId = layerId;
    this._styleValue = styles;
    this.applyStyles();
  }

  applyFilteredColumns = () => {
    if (this._featureLayers.length > 0 && !!this._filteredColumnsLayerId) {
      const feature = this._featureLayers.find(x => x.dataHandler.layerDefinition().id === this._filteredColumnsLayerId);
      feature.dataHandler.setFilteredColumns(this._filteredColumnsValue);
    }
  }

  setFilteredColumns = (layerId, filteredColumns) => {
    this._filteredColumnsLayerId = layerId;
    this._filteredColumnsValue = filteredColumns;
    this.applyFilteredColumns();
  }

  updateData = (layerId, successCallback) => {
    const feature = this._featureLayers.find(x => x.dataHandler.layerDefinition().id === layerId);
    feature.dataHandler.updateData(successCallback, this._updateDataErrorCallback);

    this.onDynamicLayerVisibilityChange(true, feature);
  }

  initializeApi() {
    if (!this.props.onApiReady)
      return;

    var api = {
      getXYZ: () => {
        var view = this.map.getView();
        var zoomLevel = view.getZoom();
        var center = Proj.toLonLat(view.getCenter());

        return [center[0], center[1], zoomLevel];
      },
      setOpacityBasemap: (opacity) => {
        this.setOpacityBasemap(opacity);
      }
    };

    this.props.onApiReady(api);
  }

  getMap = () => {
    return this.map;
  }

  isPanning() {
    return this._panning;
  }


  deactivateIdentify = () => {
    this.__activeIdentify = false;
  }
  activateIdentify = () => {
    this.__activeIdentify = true;
  }

  componentDidUpdate(prevProps) {
    // WB.1: se appConfig chegou async depois do mount, inicializar agora.
    // Bug bridge fix: dois componentDidUpdate no mesmo class — JavaScript pegava só o último.
    // Consolidado: init guard + lógica legada de update de view/layers/geoJson/config.
    if (!prevProps.appConfig && this.props.appConfig && !this.map) {
      this.initMap();
      return;
    }
    if (!prevProps.dynamicLayers && this.props.dynamicLayers) {
      this.initializeMap();
      this.applyTheme();
      this.applyStyles();
      this.applyFilteredColumns();
    }

    // Guards para casos onde map ainda não inicializou (appConfig async).
    if (!this.map) return;

    if (
      prevProps.defaultZoom !== this.props.defaultZoom ||
      prevProps.defaultLon !== this.props.defaultLon ||
      prevProps.defaultLat !== this.props.defaultLat
    ) {
      var view = this.map.getView();

      view.setZoom(this.props.defaultZoom);
      view.setCenter(Proj.fromLonLat([this.props.defaultLon, this.props.defaultLat]));
    }



    if (this.__layers && this.__layers.some(x => x.dynamic)) {
      var currKey = this.__refreshKey = (this.__refreshKey || 0) + 1;
      setTimeout(() => {
        if (currKey === this.__refreshKey) {
          for (var item of this.__layers) {
            if (!item.dynamic && !item.layer.getVisible())
              continue;

            var source = item.layer.getSource();
            // ol@10: tileCache não é mais property; usar refresh()
            if (source && typeof source.refresh === 'function') {
              source.refresh();
            }
          }
        }
      }, 1000);
    }




    if (prevProps.geoJson !== this.props.geoJson) {
      this.loadGeoJson();
    }

    const newState = {};
    let changeState = false;

    if (prevProps.config.activeBasemap !== this.props.config.activeBasemap && this.props.config.activeBasemap) {
      changeState = true;
      newState.activeBasemap = this.props.config.activeBasemap;
    }
    if (prevProps.config.lastBasemap !== this.props.config.lastBasemap && this.props.config.lastBasemap) {
      changeState = true;
      newState.lastBasemap = this.props.config.lastBasemap;
    }
    if (prevProps.config.activeLayer !== this.props.config.activeLayer && this.props.config.activeLayer) {

      if (this.__layers) {
        changeState = true;
        const allowMultipleOverlays = this.state.mapConfig ? this.state.mapConfig.allowMultipleOverlays : false;
        if (allowMultipleOverlays)
          newState.activeLayer = this.props.config.activeLayer;
        else
          newState.activeLayer = [this.props.config.activeLayer[this.props.config.activeLayer.length - 1]];
      }

    }
    if (prevProps.config.showLayer !== this.props.config.showLayer) {
      changeState = true;
      newState.showLayer = !!this.props.config.showLayer;
    }

    if (changeState) {

      this.setState(newState,
        () => {
          this.updateBasemap();
          this.updateLayer();
        }
      );
    }
  }

  createResizeObserver = () => {
    this.__resizeObserver = new ResizeObserver(() => {
      this.map.updateSize();
    });

    this.__resizeObserver.observe(this.mapRef.current);

    // W13s: spinner ate o primeiro 'rendercomplete' do OL (todos os tiles
    // do viewport atual renderizados). Fallback 8s caso evento nao dispare.
    if (this.map) {
      const stopSpinner = () => {
        if (this.state && this.state.loadingTiles) {
          this.setState({ loadingTiles: false });
        }
      };
      this.map.once("rendercomplete", () => {
        // W13t: garantir size correto + re-centralizar apos primeiro paint
        // (cobre caso em que container ganhou tamanho final apos init).
        this.map.updateSize();
        reCalibrate();
        stopSpinner();
      });
      this.__tileLoadFallback = setTimeout(stopSpinner, 8000);
    }

    // W13h: forcar updateSize + re-fit ao initial center logo apos init.
    // OL calcula tamanho do canvas no momento da criacao; se o container ainda
    // estava colapsado (CSS calc(100vh - X) nao aplicado), os tiles ficam
    // calibrados para size 0 e aparecem deslocados.
    // requestAnimationFrame garante que o layout do browser ja correu.
    // A geoJson already loaded is the view's subject; falling back to the city center would
    // discard the fit loadGeoJson made before the first render.
    const reCalibrate = () => {
      if (!this.map || !this.mapRef.current) return;
      this.map.updateSize();
      if (this.fitGeoJson()) return;
      const { appConfig } = this.props;
      if (appConfig) {
        const view = this.map.getView();
        const center = Proj.fromLonLat([
          Number(appConfig.mapInitialPositionLongitude),
          Number(appConfig.mapInitialPositionLatitude),
        ]);
        view.setCenter(center);
        view.setZoom(Number(appConfig.mapInitialPositionZoomLevel));
      }
    };
    requestAnimationFrame(reCalibrate);
    // Segundo retry depois que tiles podem ter chegado
    setTimeout(reCalibrate, 200);
    // Terceiro retry mais tarde (cobre container que ganhou tamanho async)
    setTimeout(reCalibrate, 800);
  }

  showExtent(geographicExtent) {
    var geographicCoords = [
      Extent.getBottomLeft(geographicExtent),
      Extent.getBottomRight(geographicExtent),
      Extent.getTopRight(geographicExtent),
      Extent.getTopLeft(geographicExtent),
      Extent.getBottomLeft(geographicExtent)
    ];


    var geojsonObject = {
      type: "Feature",
      id: 9999,
      properties: {
        selectExtent: true
      },
      geometry: {
        type: "Polygon",
        coordinates: [geographicCoords]
      }
    };

    var source = this.__geoJsonLayer.getSource();
    var newFeature = source.getFormat().readFeature(geojsonObject);

    var oldFeature = source.getFeatureById(geojsonObject.id);
    if (oldFeature)
      source.removeFeature(oldFeature);

    source.addFeature(newFeature);

    setTimeout(() => {
      var oldFeature = source.getFeatureById(geojsonObject.id);
      if (oldFeature === newFeature) source.removeFeature(oldFeature);
    }, 150);
  }


  initializeIdentify = () => {

    if (this.props.identifyOnExtent) {

      var dragBox = new DragBox({
        condition: (evt) => {
          if (this.__activeIdentify) {
            return EventsCondition.platformModifierKeyOnly(evt);
          }
          return false;
        }
      });

      this.map.addInteraction(dragBox);

      dragBox.on("boxend", () => {
        if (!this.__activeIdentify) return;

        var extent = dragBox.getGeometry().getExtent();

        var lonLat1 = Proj.toLonLat(Extent.getBottomLeft(extent));
        var lonLat2 = Proj.toLonLat(Extent.getTopRight(extent));

        var geographicExtent = Extent.boundingExtent([lonLat1, lonLat2]);

        this.identifyOnExtent(geographicExtent);
      });
    }


    this.map.on("click", evt => {
      if (!this.__activeIdentify) return;

      if (this.props.identifyOnExtent) {
        this.identifyOnPixel(evt.pixel);
      }

      if (this.props.identifyOnLayer) {

        var coord = this.map.getCoordinateFromPixel(evt.pixel);
        var lonLat = Proj.toLonLat(coord);

        this.identifyOnLayer(this.props.identifyLayerId, lonLat, this.props.identifyOnLayer);

      }
    });
  }

  identifyOnPixel(pixel) {
    const { identifyOnPixelTolerance } = this.props;

    var coord1 = this.map.getCoordinateFromPixel([
      pixel[0] - identifyOnPixelTolerance,
      pixel[1] - identifyOnPixelTolerance
    ]);
    var coord2 = this.map.getCoordinateFromPixel([
      pixel[0] + identifyOnPixelTolerance,
      pixel[1] + identifyOnPixelTolerance
    ]);

    var lonLat1 = Proj.toLonLat(coord1);
    var lonLat2 = Proj.toLonLat(coord2);

    var geographicExtent = Extent.boundingExtent([lonLat1, lonLat2]);

    this.showExtent(geographicExtent);

    this.identifyOnExtent(geographicExtent);
  }

  identifyOnExtent(geographicExtent) {
    if (this.props.identifyOnExtent) {
      this.props.identifyOnExtent(geographicExtent);
    }
  }


  identifyOnLayer = (layerId, coordinate, callback) => {

    var found = false;
    this._featureLayers.forEach(item => {
      if (item.id !== layerId)
        return;

      found = true;

      var source = item.dataHandler.source();

      if (!source.initialized() || !source.visible()) {
        callback(null, "Layer \"" + item.label + "\" está desligada! Ligue a camada da layer para poder visualizá-lo.");
        return;
      }

      var projectedCoord = Proj.fromLonLat(coordinate);
      var resolution = this.map.getView().getResolution();

      var tolerance = resolution * 4;

      var proj1 = [projectedCoord[0] - tolerance, projectedCoord[1] - tolerance];
      var proj2 = [projectedCoord[0] + tolerance, projectedCoord[1] + tolerance];

      var projectedExtent = Extent.boundingExtent([proj1, proj2]);

      this._showExtent(projectedExtent);

      var geographicExtent = Extent.boundingExtent([
        Proj.toLonLat(proj1),
        Proj.toLonLat(proj2)
      ]);

      var executed = source.identify(geographicExtent, resolution, null, callback);
      if (!executed)
        callback(null, "Layer \"" + item.dataHandler.layerDefinition().name + "\" não está pronta! Aguarde o carregamento!");

    });

    if (!found)
      callback(null, "Layer não encontrada!");
  }

  initializeEditGeometry = () => {
    const source = this.__geoJsonLayer.getSource();
    var modify = new Modify({
      source: source,
      condition: (evt) => {
        if (this.__activeIdentify) {
          return EventsCondition.primaryAction(evt);
        }
        return false;
      },
      deleteCondition: evt => { return EventsCondition.singleClick(evt); }
    });

    this.map.addInteraction(modify);

    modify.on("modifyend", evt => {
      var feature = evt.features.getArray()[0];
      var modifiedGeoJson = source.getFormat().writeGeometry(feature.getGeometry());

      this.props.onEditGeometry(modifiedGeoJson);
    });
  }

  updateConfigMap = () => {
    const { mapConfig, activeBasemap, lastBasemap, activeLayer, showLayer } = this.state;

    if (!mapConfig) return;

    // Guard contra mapConfig sem overlays (mesmo bug do loadOverLays).
    const legend = (mapConfig.overlays || []).map(x => {
      if (activeLayer.some(y => y === `${x.mapService.id}__${x.mapService.serviceName}`)) {
        return x.mapService.legendConfig;
      }
      return null;
    }).filter(x => !!x);

    var view = this.map.getView();
    var defaultZoom = view.getZoom();

    var center = Proj.toLonLat(view.getCenter());

    var defaultLon = center[0];
    var defaultLat = center[1];

    this.props.updateConfigMap({
      defaultLon,
      defaultLat,
      defaultZoom,

      activeBasemap,
      lastBasemap,
      activeLayer,
      showLayer,
      legend: legend
    });
  }

  onBasemapChange = (newValue) => {
    let currValue = this.state.activeBasemap;

    let currBasemap = this.__basemaps.find(item => item.value === currValue);
    let newBasemap = this.__basemaps.find(item => item.value === newValue);

    this.setState({ activeBasemap: newValue, lastBasemap: currValue }, () => {
      this.updateBasemap();
      this.updateConfigMap();
    });
  }

  onBasemapSwitch = () => {
    this.onBasemapChange(this.state.lastBasemap);
  }

  setOpacityBasemap = (opacity) => {
    this.__basemaps.forEach(item => {
      if (item.layer)
        item.layer.setOpacity(opacity);
    });

  }

  updateBasemap = () => {
    const currValue = this.state.activeBasemap;

    this.__basemaps.forEach(item => {
      if (item.layer) {
        item.layer.setVisible(item.value === currValue);
      }
    });

  }



  handleVisibleChange = popoverVisible => {
    this.setState({ popoverVisible });
  };

  onLayerVisibilityChange = (newValue) => {
    this.setState({ showLayer: !!newValue }, () => {
      this.updateLayer();
      this.updateConfigMap();
    });
  }

  //activeDynamicLayer
  onDynamicLayerVisibilityChange = (e, layer) => {

    const checked = (typeof e === "boolean") ? e : e.target.checked;
    const activeDynamicLayer = this.state.activeDynamicLayer.slice();

    if (checked) {
      if (activeDynamicLayer.indexOf(layer.id) === -1)
        activeDynamicLayer.push(layer.id);
    }
    else {
      activeDynamicLayer.splice(activeDynamicLayer.indexOf(layer.id), 1);
    }

    this.setState({ activeDynamicLayer: activeDynamicLayer }, () => {
      // W13g: setVisible apenas no layer modificado (evita re-render dos demais).
      const featureLayer = this._featureLayers.find(fl => fl.id === layer.id);
      if (featureLayer && featureLayer.mapLayer) {
        featureLayer.mapLayer.setVisible(checked);
      }
    });
  }

  checkLayer = (e, layer) => {
    // W13e: aceita boolean direto (Mantine onChange) OU evento legado (e.target.checked)
    const checked = (typeof e === "boolean") ? e : e.target.checked;
    const activeLayer = this.state.activeLayer.slice();

    if (checked) {
      if (activeLayer.indexOf(layer.value) === -1)
        activeLayer.push(layer.value);
    }
    else {
      activeLayer.splice(activeLayer.indexOf(layer.value), 1);
    }


    this.setState({ activeLayer: activeLayer }, () => {
      // W13g: toggle incremental — antes chamava updateLayer() que iterava todos os
      // __layers e chamava tileCache.clear() + changed() em cada ativo, fazendo o
      // mapa piscar (re-download de todos os tiles) a cada checkbox.
      this.toggleSingleLayer(layer, checked);
      this.updateConfigMap();
    });
  }

  /**
   * W13g: alterna visibilidade de UM layer sem afetar os demais.
   * Reutiliza tiles ja cacheados (nao limpa tileCache nem dispara source.changed()).
   * Usado por checkLayer (toggle individual via checkbox do "Tema de Referencia").
   */
  toggleSingleLayer = (layer, visible) => {
    if (!this.__layers) return;
    const item = this.__layers.find(x => x.value === layer.value);
    if (!item || !item.layer) return;
    // Apenas setVisible — OpenLayers reusa tiles do cache se ja foram baixados.
    item.layer.setVisible(visible && this.state.showLayer);
  }

  onLayerChange = (newValue) => {
    this.setState({ activeLayer: [newValue] }, () => {
      this.updateLayer();
      this.updateConfigMap();
    });
  }

  updateLayer = () => {
    const currValue = this.state.showLayer ? this.state.activeLayer : [];

    this.__layers.forEach(item => {
      if (item.layer) {
        item.layer.setVisible(currValue.some(y => y === item.value));

        if (currValue.some(y => y === item.value)) {
          var source = item.layer.getSource();
          // ol@10: tileCache não é mais property; usar refresh() que faz clear+changed
          if (source && typeof source.refresh === 'function') {
            source.refresh();
          }
        }
      }
    });
  }



  // -----------------------------------------------------------
  // Layer Bind Methods
  // -----------------------------------------------------------

  _updateDataErrorCallback = (error) => {

    if (error === 'STOP')
      return;

    if (this.props.onRefreshRequired)
      this.props.onRefreshRequired();
  }

  _updateRelatedData = (dataHandler) => {

    var featureId = dataHandler.layerDefinition().featureId;

    this._featureLayers.forEach(item => {
      var layerDef = item.dataHandler.layerDefinition();

      if (layerDef.featureId === featureId) {
        item.dataHandler.updateData(null, this._updateDataErrorCallback);
      }

    });
  }

  _onLayerUpdateRequested = (dataHandler) => {
    this._updateRelatedData(dataHandler);
  }

  _onLayerDefinitionChanged = (dataHandler) => {

    dataHandler.updateData(null, this._updateDataErrorCallback);
  }

  _onLayerVisibilityChanged = (dataHandler, value) => {

    var layerDefinition = dataHandler.layerDefinition();
    var featureLayer = this._featureLayers.find(x => x.id === layerDefinition.id);

    featureLayer.mapLayer.setVisible(value);

    if (!value) {
      dataHandler.stopDataRequests();

      if (!dataHandler.gridVisible())
        dataHandler.clearSelection();

      return;
    }

    dataHandler.updateData(null, this._updateDataErrorCallback);
  }

  _onGridVisibilityChanged = (dataHandler, value) => {
    if (!value && !dataHandler.visible())
      dataHandler.clearSelection();
  }

  _onLayerSearchTextChanged = (dataHandler, value) => {
    dataHandler.updateData(null, this._updateDataErrorCallback);
  }

  _onLayerFilteredColumnsChanged = (dataHandler, value) => {

    dataHandler.updateData(null, this._updateDataErrorCallback);
  }

  _onLayerRemoved = (dataHandler) => {

    dataHandler.removeListener(LayerDataHandlerListenerKeys.LAYER_DEFINITION_CHANGED, this._onLayerDefinitionChanged);
    dataHandler.removeListener(LayerDataHandlerListenerKeys.VISIBLE_CHANGED, this._onLayerVisibilityChanged);
    dataHandler.removeListener(LayerDataHandlerListenerKeys.GRID_VISIBLE_CHANGED, this._onGridVisibilityChanged);
    dataHandler.removeListener(LayerDataHandlerListenerKeys.SEARCH_TEXT_CHANGED, this._onLayerSearchTextChanged);
    dataHandler.removeListener(LayerDataHandlerListenerKeys.DISPOSE_REQUESTED, this._onLayerRemoved);
    dataHandler.removeListener(LayerDataHandlerListenerKeys.UPDATE_REQUESTED, this._onLayerUpdateRequested);
  }

  _setLoadingStatus(layerId, percent, count) {
    if (!this._loadingStatus[layerId])
      this._loadingStatus[layerId] = {};

    this._loadingStatus[layerId].percent = percent;
    this._loadingStatus[layerId].count = count;


    var totalDone = 0;
    var totalCount = 0;
    var loadingInfo = false;

    for (var key in this._loadingStatus) {
      if (this._loadingStatus[key].count < 0) {
        loadingInfo = true;
      }
      else {
        totalCount += this._loadingStatus[key].count;
        totalDone += this._loadingStatus[key].percent * this._loadingStatus[key].count;
      }
    }

    var message = "";

    if (totalDone === totalCount && totalCount > 0) {
      if (this.state.loadingPercent === 100)
        return;

      message = "Dados carregados";

      setTimeout(() => {
        if (this.state.loadingPercent === 100) {
          this.setState({ loadingMessage: "" });

          this._loadingStatus = {};
        }
      }, 600);
    }

    if (totalDone < totalCount) {
      message = totalCount === 1 ? "1 registro" : totalCount + " registros";
    }
    else {
      if (loadingInfo)
        message = "Verificando quantidade";
    }

    this.setState({
      loadingMessage: message,
      loadingPercent: totalCount > 0 ? Math.floor(totalDone / totalCount * 100) : 0
    });
  }


  _showExtent(geographicExtent) {
    var geographicCoords = [
      Extent.getBottomLeft(geographicExtent),
      Extent.getBottomRight(geographicExtent),
      Extent.getTopRight(geographicExtent),
      Extent.getTopLeft(geographicExtent),
      Extent.getBottomLeft(geographicExtent)
    ];


    var geojsonObject = {
      type: "Feature",
      id: 0,
      geometry: {
        type: "Polygon",
        coordinates: [geographicCoords]
      }
    };

    var source = this.__geoJsonLayer.getSource();
    var newFeature = source.getFormat().readFeature(geojsonObject);

    var oldFeature = source.getFeatureById(geojsonObject.id);
    if (oldFeature) source.removeFeature(oldFeature);

    source.addFeature(newFeature);

    setTimeout(() => {
      var oldFeature = source.getFeatureById(geojsonObject.id);
      if (oldFeature === newFeature) source.removeFeature(oldFeature);
    }, 150);
  }



  // W13d: Mantine Select aceita array {value,label} (legado antd usava Select.Option)
  getBasemapOptions = () => {
    if (!this.__basemaps) return [];
    return this.__basemaps.map(x => ({ value: String(x.value), label: x.label }));
  }

  getLayerOptions = () => {
    if (!this.__layers) return [];
    return this.__layers.map(x => ({ value: String(x.value), label: x.label }));
  }

  renderLayerCheck = () => {
    if (!this.__layers) return null;

    const { activeLayer, activeDynamicLayer } = this.state;

    return (

      <Stack gap={4} w={260}>
        {(!!this._featureLayers && this._featureLayers.length > 0) &&
          this._featureLayers.map(x => (
            <Checkbox
              key={x.id}
              size="xs"
              label={x.label}
              checked={activeDynamicLayer.some(y => y === x.id)}
              onChange={(e) => this.onDynamicLayerVisibilityChange(e.currentTarget.checked, x)}
            />
          ))
        }

        {(!!this.__layers && this.__layers.length > 0) &&
          this.__layers.map(x => (
            <Checkbox
              key={x.value}
              size="xs"
              label={x.label}
              checked={activeLayer.some(y => y === x.value)}
              onChange={(e) => this.checkLayer(e.currentTarget.checked, x)}
            />
          ))
        }
      </Stack>);
  }

  renderCustomTools = () => {
    const { controls } = this.props;

    if (!controls || controls.length === 0) {
      return null;
    }

    return (
      controls.map(x => (
        <div key={x} className="ol-control ol-unselectable">
          <button onClick={x.action} title={x.title}>
            {typeof (x.icon) === "string" && <FontAwesomeIcon icon={x.icon} size="sm" />}
            {typeof (x.icon) !== "string" && x.icon}
          </button>
        </div>
      )
      )
    );
  }

  render() {
    const { infoText } = this.props;
    const { mapConfig } = this.state;

    const enableMeasureTool = mapConfig ? mapConfig.enableMeasureTool : false;
    const enableGoToCoordinateTool = mapConfig ? mapConfig.enableGoToCoordinateTool : false;
    const allowMultipleOverlays = mapConfig ? mapConfig.allowMultipleOverlays : false;

    return (
      <div style={{ height: "100%", position: "relative" }}>
        <div ref={this.mapRef} className="map" style={this.props.style} />
        {infoText &&
          <div className="ol-control ol-unselectable btn-map-info">
            {/* W14a — botão fica no bottom-right da stack do shell; popover abre acima+esquerda
                pra não sair da viewport e não cobrir os outros controles. */}
            <Popover position="top-end" withinPortal={false} shadow="md">
              <Popover.Target>
                <button title="Ajuda">
                  <IconQuestionMark size={14} />
                </button>
              </Popover.Target>
              <Popover.Dropdown>{infoText}</Popover.Dropdown>
            </Popover>
          </div>
        }

        <div className="map-custom-tools">
          {enableGoToCoordinateTool &&
            <GoToCoordinatesTool
              mapKey={this.props.mapKey}
              getMap={this.getMap}
              setMarker={this.setMarker}
              clearMarker={this.clearMarker}
            />}

          {this.renderCustomTools()}
        </div>

        {enableMeasureTool &&
          <MeasureTool
            mapKey={this.props.mapKey}
            getMap={this.getMap}
            isPanning={this.isPanning}
            activateIdentify={this.activateIdentify}
            deactivateIdentify={this.deactivateIdentify}
          />
        }

        {!!mapConfig &&
          <Paper className="map-tools" withBorder shadow="sm" radius="md" p="xs">
            <Stack gap="xs">
              <Group gap="xs" wrap="nowrap">
                <Select
                  size="xs"
                  w={220}
                  data={this.getBasemapOptions()}
                  value={String(this.state.activeBasemap ?? "")}
                  onChange={(v) => v && this.onBasemapChange(v)}
                  allowDeselect={false}
                  comboboxProps={{ withinPortal: false }}
                />
                <Button
                  size="xs"
                  variant="filled"
                  onClick={this.onBasemapSwitch}
                  title="Troca-rápida"
                  px={6}
                >
                  <IconArrowBackUp size={14} />
                </Button>
              </Group>

              {(((!!this.__layers && this.__layers.length > 0) || (!!this._featureLayers && this._featureLayers.length > 0)) && allowMultipleOverlays) &&
                <Popover
                  position="bottom"
                  opened={this.state.popoverVisible}
                  onChange={(o) => this.handleVisibleChange(o)}
                  withinPortal={false}
                  shadow="md"
                  width={280}
                >
                  <Popover.Target>
                    <Button
                      size="xs"
                      variant="default"
                      fullWidth
                      rightSection={<IconCaretDown size={14} />}
                      onClick={() => this.handleVisibleChange(!this.state.popoverVisible)}
                    >
                      Tema de Referência
                    </Button>
                  </Popover.Target>
                  <Popover.Dropdown>
                    {this.renderLayerCheck()}
                  </Popover.Dropdown>
                </Popover>
              }

              {!allowMultipleOverlays && (!!this._featureLayers && this._featureLayers.length > 0) &&
                <Stack gap={4}>
                  {this._featureLayers.map(x => (
                    <Group key={x.id} gap={6} justify="space-between" wrap="nowrap">
                      <Paper px="xs" py={2} withBorder w={200}>
                        {x.label}
                      </Paper>
                      <Switch
                        size="xs"
                        checked={!!this.state.activeDynamicLayer.some(y => y === x.id)}
                        onChange={(e) => this.onDynamicLayerVisibilityChange(e.currentTarget.checked, x)}
                      />
                    </Group>
                  ))}
                </Stack>
              }
              {!allowMultipleOverlays && (!!this.__layers && this.__layers.length > 0) &&
                <Group gap={6} wrap="nowrap">
                  <Select
                    size="xs"
                    w={220}
                    data={this.getLayerOptions()}
                    value={String(this.state.activeLayer ?? "")}
                    onChange={(v) => v && this.onLayerChange(v)}
                    disabled={!this.state.showLayer}
                    allowDeselect={false}
                    comboboxProps={{ withinPortal: false }}
                  />
                  <Switch
                    size="xs"
                    checked={!!this.state.showLayer}
                    onChange={(e) => this.onLayerVisibilityChange(e.currentTarget.checked)}
                  />
                </Group>
              }
            </Stack>
          </Paper>
        }
        {/* W13s: overlay spinner enquanto tiles iniciais carregam */}
        {this.state.loadingTiles &&
          <div className="map-tiles-loading-overlay">
            <Loader size="md" color="gray" />
            <div className="map-tiles-loading-text">Carregando mapa…</div>
          </div>
        }
        {!!this.state.loadingMessage &&
          <div className="map-spin">
            <Loader size={80} />
            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                margin: "0px 10px"
              }}
            >
              <h2 className="map-spin-status">Carregando</h2>
              <div> {this.state.loadingMessage} </div>
            </div>
          </div>
        }
      </div>
    );
  }
}


function mapStateToProps(state) {

  return {
    config: state.smartMap.config,

    appConfig: state.container.config,
  };
}

export default connect(mapStateToProps, smartMapActions, null, { forwardRef: true })(SmartMap);